import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { IoHomeOutline, IoHomeSharp } from "react-icons/io5";
import { RiAccountCircleLine } from "react-icons/ri";
import { MdCall, MdDisplaySettings, MdOutlinePointOfSale } from "react-icons/md";
import { FaKeyboard, FaRegKeyboard } from "react-icons/fa";
import point_of_sale from "../accounting_assets/point_of_sale_60dp_184BC4_FILL0_wght300_GRAD0_opsz48.png";
import Cookies from "js-cookie";
import Photosicon from "../../assets/photos_icon.png";
import "../../body_root/Navbar.css";

export default function AccountingNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [guid, setGuid] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [userlogin, setUserlogin] = useState(false);

  const params = new URLSearchParams(location.search);
  const activePage = params.get("page") || "";

  useEffect(() => {
    const existingUser = Cookies.get("guid");
    const sessiontoken = Cookies.get("sessiontoken");

    if (existingUser && sessiontoken) {
      setGuid(existingUser);
      setUserlogin(true);
      setPhotoURL(Cookies.get("photoURL") || "");
    } else {
      setUserlogin(false);
    }
  }, []);

  return (
    <nav className="navbar">

      {/* HOME */}
      <div
        onClick={() => navigate("/accounting")}
        className={`menubutton-icon ${location.pathname === "/" ? "active" : ""}`}
      >
        {location.pathname === "/" ? (
          <IoHomeSharp className="icon" />
        ) : (
          <IoHomeOutline className="icon" />
        )}
        <span className="button-text">Home</span>
      </div>

      {/* ACCOUNTING */}
      <div
        onClick={() => navigate("/accounting?page=pos-receipt")}
        className={`menubutton-icon ${
          activePage === "pos-receipt" ? "active" : ""
        }`}
      >
       
          <MdOutlinePointOfSale className="icon" />
         
        <span className="button-text">Accounting</span>
      </div>

      {/* PHONEBOOK */}
      <div
        onClick={() => navigate("/accounting?page=settings")}
        className={`menubutton-icon ${
          activePage === "settings" ? "active" : ""
        }`}
      >
        <MdDisplaySettings className="icon" />
        <span className="button-text">Settings</span>
      </div>

      {/* ACCOUNT / LOGIN */}
      <div
        className={`menubutton-icon ${
          activePage === "account" ? "active" : ""
        }`}
      >
        {userlogin ? (
          <img
            src={photoURL || Photosicon}
            onClick={() => navigate("/accounting?page=account")}
            onError={(e) => (e.currentTarget.src = Photosicon)}
            className="img-icon rounded-circle shadow hover"
            alt="profile"
          />
        ) : (
          <div className="login_button" onClick={() => navigate("/login")}>
            <RiAccountCircleLine className="icon" />
          </div>
        )}
      </div>

    </nav>
  );
}
